import SessionTimeoutPrompt from './component'
export default SessionTimeoutPrompt
